import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { persistStore } from 'redux-persist';

import { btcListenerMiddleware, listenerMiddleware } from 'modules/auth';
import { dialogSlice } from 'modules/dialogs';

import { web3Api } from './web3Api';

const rootReducer = combineReducers({
  [web3Api.reducerPath]: web3Api.reducer,
  [dialogSlice.name]: dialogSlice.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      // TODO: fix serializable error
      // https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
      serializableCheck: false,
    })
      .concat(listenerMiddleware.middleware)
      .concat(btcListenerMiddleware.middleware)
      .concat(web3Api.middleware),
});

setupListeners(store.dispatch);

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
